import React from 'react'
import '../Services_details.css';

export default function Services_website() {

    const Features1 = () => {
        return (
            <div className="features_container">
                <div className="features">
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Hosting (FREE)</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Responsive Design</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>SEO Friendly</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>3 - 6 Pages</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>CSS Animations</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Quick Enquiry Form</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Social Media Integration</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>Admin Panel</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>Payment Gateways</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Github Integration</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Post Project Support</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>ChatBot Support</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>Premium Designs</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>Performance Optimization</h3>
                    </div>
                </div>
            </div>
        );
    };

    const Features2 = () => {
        return (
            <div className="features_container">
                <div className="features">
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Hosting (FREE)</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Responsive Design</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>SEO Friendly</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>6 - 12 Pages</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>CSS Animations</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Quick Enquiry Form</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Social Media Integration</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Admin Panel</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Payment Gateways</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Github Integration</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Post Project Support</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>ChatBot Support</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>Premium Designs</h3>
                    </div>
                    <div className="feature-item2">
                        <i className="bx bx-x"></i>
                        <h3>Performance Optimization</h3>
                    </div>
                </div>
            </div>
        );
    };

    const Features3 = () => {
        return (
            <div className="features_container">
                <div className="features">
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Hosting (FREE)</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Responsive Design</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>SEO Friendly</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Pages (Your wish)</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>CSS Animations</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Quick Enquiry Form</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Social Media Integration</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Admin Panel</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Payment Gateways</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Github Integration</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Post Project Support</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>ChatBot Support</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Premium Designs</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Performance Optimization</h3>
                    </div>
                </div>
            </div>
        );
    };

    const Ecommerce = () => {
        return (
            <div className="features_container">
                <div className="features">
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Hosting (FREE)</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Responsive Design</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Performance Optimization</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Admin Panel</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Product listing Screen</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Product detail view</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Wishlist and favourites</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Search functionality</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Payment Gateways</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>User Profile Screen</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Order History / Tracking</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Post Project Support</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Premium Designs</h3>
                    </div>
                    <div className="feature-item">
                        <i className="bx bx-check"></i>
                        <h3>Github Integration</h3>
                    </div>
                </div>
            </div>
        );
    };


    return (
        <div className="content-box">
            <h3 className='heading-main'>Website Development</h3>
            <p>
                At our core, we specialize in creating dynamic, responsive, and user-friendly websites that are tailored to meet your unique business needs. Our web development process encompasses the latest technologies and best practices to ensure that your website stands out in the digital landscape.
            </p>
            <h4>Our Expertise</h4>
            <p>
                We offer comprehensive web development services that cover:
            </p>
            <h4>1. Front-End Development</h4>
            <p>
                Our front-end development services focus on crafting visually appealing and interactive user interfaces. We use the following technologies:
                <ul>
                    <li><strong>HTML</strong>: The latest version of HTML for structuring web content.</li>
                    <li><strong>CSS</strong>: Advanced CSS for styling and layout design.</li>
                    <li><strong>JavaScript</strong>: Powerful scripting language for creating dynamic content.</li>
                    <li><strong>React.js</strong>: A modern JavaScript library for building user interfaces.</li>
                </ul>
            </p>
            <h4>2. Back-End Development</h4>
            <p>
                Our back-end development ensures your website functions smoothly and efficiently. We specialize in:
                <ul>
                    <li><strong>Node.js</strong>: Fast and scalable server-side runtime.</li>
                    <li><strong>Express.js</strong>: A flexible Node.js web application framework.</li>
                    <li><strong>Databases</strong>: Including MySQL, SQLite, Realm and Firebase (Google Cloud) for reliable data management.</li>
                    <li><strong>APIs</strong>: Creating and integrating APIs for seamless data exchange.</li>
                </ul>
            </p>
            <h4>3. Full-Stack Development</h4>
            <p>
                Our full-stack development service provides an all-in-one solution, combining both front-end and back-end expertise to deliver comprehensive web applications.
            </p>
            <h4>Key Aspects of Our Web Development</h4>
            <p>
                We ensure your website excels in the following areas:
                <ul>
                    <li><strong>Responsive Design</strong>: Optimized for all devices and screen sizes.</li>
                    <li><strong>Performance Optimization</strong>: Fast loading times and efficient resource use.</li>
                    <li><strong>Security</strong>: Robust measures to protect your website from threats.</li>
                    <li><strong>SEO</strong>: Enhanced visibility on search engines.</li>
                </ul>
            </p>
            <h4>Our Web Development Process</h4>
            <p>
                From initial consultation to ongoing maintenance, our process includes:
                <ul>
                    <li><strong>Planning</strong>: Understanding your goals and defining the project scope.</li>
                    <li><strong>Design</strong>: Creating intuitive and attractive UI/UX designs.</li>
                    <li><strong>Development</strong>: Coding both the front-end and back-end components.</li>
                    <li><strong>Testing</strong>: Rigorous testing to ensure flawless functionality.</li>
                    <li><strong>Deployment</strong>: Launching your website live.</li>
                    <li><strong>Maintenance</strong>: Regular updates and support.</li>
                </ul>
            </p>

            <div className='packages'>
                <h2 className="heading">Packages</h2>
                <div className="packages-container">
                    <div className="package-box">
                        <div className='box-two'>
                            <h3>Basic</h3>
                            <h4>Website Development Package</h4>
                        </div>
                        <p>The Basic Package is perfect for beginners looking to get essential tools and guidance to launch their project or business confidently.
                        </p>

                        <Features1 />

                        <h4 className='cost'><strong>Cost: </strong>₹8,000 - ₹15,000</h4>
                        <a
                            href='https://wa.me/919384392655?text=I%20want%20to%20know%20more%20details%20about%20Basic%20Package%20for%20Website'
                            className='btn2'>
                            Contact for OFFERS
                        </a>

                    </div>

                    <div className="package-box">
                        <div className='box-two'>
                            <h3>Pro</h3>
                            <h4>Website Development Package</h4>
                        </div>
                        <p>The Pro Package is designed for businesses aiming to expand and scale. It includes advanced features and support to accelerate your growth trajectory.</p>

                        <Features2 />

                        <h4 className='cost'><strong>Cost: </strong>₹15,000 - ₹35,000</h4>
                        <a
                            href='https://wa.me/919384392655?text=I%20want%20to%20know%20more%20details%20about%20Pro%20Package%20for%20Website'
                            className='btn2'>
                            Contact for OFFERS
                        </a>
                    </div>

                    <div className="package-box">
                        <div className='box-two'>
                            <h3>Pro-Plus</h3>
                            <h4>Website Development Package</h4>
                        </div>
                        <p>The Pro-Plus Package offers comprehensive solutions tailored for established businesses seeking top-tier tools and personalized service to maintain leadership in their industry.</p>

                        <Features3 />

                        <h4 className='cost'><strong>Cost: </strong>₹35,000 - ₹X,XX,XXX</h4>
                        <a
                            href='https://wa.me/919384392655?text=I%20want%20to%20know%20more%20details%20about%20Pro-Plus%20Package%20for%20Website'
                            className='btn2'>
                            Contact for OFFERS
                        </a>
                    </div>

                    <div className="package-box">
                        <div className='box-two'>
                            <h3>Ecommerce Plan</h3>
                            <h4>Website Development Package</h4>
                        </div>
                        <p>Experience the pinnacle of ecommerce success with our Ecommerce Plan Package. Get top-tier tools and personalized service to keep your business at the forefront of the industry.</p>

                        <Ecommerce />

                        <h4 className='cost'><strong>Cost: </strong>₹30,000 - ₹X,XX,XXX</h4>
                        <a
                            href='https://wa.me/919384392655?text=I%20want%20to%20know%20more%20details%20about%20Ecommerce%20Plan%20Package%20for%20Website'
                            className='btn2'>
                            Contact for OFFERS
                        </a>
                    </div>
                </div>
            </div>

        </div>
    )
}